module.exports = __webpack_public_path__ + "static/media/YF87_9.1627700d.jpg";